// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3ki3l","loaderOuter":"PageOverlayLoader_loaderOuter__1rYIr"};